import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { useCognito } from 'components/Cognito/CognitoContextProvider'

export default function RememberDevice({ rememberDevice, onChange }) {
  const { t } = useTranslation()
  const { challenge } = useCognito()

  if (!challenge) {
    return null
  }

  return (
    <div className="mfa-challenge__remember-device">
      <div className="d-flex align-items-start gap-3">
        <label className="custom-check setting-checkbox custom-check--navy">
          <input
            className="custom-check__input"
            id="remember-device"
            type="checkbox"
            checked={rememberDevice}
            onChange={(e) => {
              e.stopPropagation()
              onChange(!rememberDevice)
            }}
          />
          <span className="custom-check__box"></span>
        </label>
        <span>
          {t('Login.mfa.rememberDevice')}
        </span>
      </div>
    </div>
  )
}

RememberDevice.propTypes = {
  rememberDevice: PropTypes.bool,
  onChange: PropTypes.func,
}
